module.exports = __webpack_public_path__ + "img/AT0000002591368.6ecfd942.png";